import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  header: {
    id: 'components.approve.header',
    defaultMessage: 'Approve',
  },
  terms: {
    id: 'components.approve.terms',
    defaultMessage: 'I agree with <a href="https://art.art/terms/" target="_blank" rel="noopener">terms and conditions</a>',
  },
  submitButton: {
    id: 'components.approve.submitButton',
    defaultMessage: 'Approve',
  },
});



// WEBPACK FOOTER //
// ./src/components/Approve/messages.js